import { apiClient } from "../clientApi";
import type { AxiosResponse } from "axios";

export interface userDetails {
  completed_sessions: number;
  created_at: string;
  education: null;
  email: string;
  experience: string;
  first_name: string;
  id: number;
  last_name: string;
  profile_pic_url: string;
  skills: string;
  total_sessions: number;
  updated_at: string;
  user_type: string;
  stats: {
    total_sessions: number;
    completed_sessions: number;
    total_time_seconds: number;
    total_time_human: string;
    avg_feedback: number;
    max_feedback: number;
  };
  sessions: {
    session_id: string;
    createdAt: string;
    completed: string;
    conversationDuration: number;
    courseName: string;
    description: string;
    patient: string;
    pretest: { mcq_correct: number; mcq_total: number; mcq_percent: number; oeq_total: number; display: string };
    posttest: { mcq_correct: number; mcq_total: number; mcq_percent: number; oeq_total: number; display: string };
    avg_score: number;
  }[];
}

export const getUsersDetails = async (id: number | string, detailed?: boolean) => {
  const { data } = await apiClient.get<userDetails, AxiosResponse<userDetails>>(
    `/users/${id}${detailed ? "/detailed" : ""}`
  );

  return data as userDetails;
};
